import { render, staticRenderFns } from "./MainSites.vue?vue&type=template&id=646bbf04"
import script from "./MainSites.vue?vue&type=script&lang=js"
export * from "./MainSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports